// extracted by mini-css-extract-plugin
module.exports = {"tag":"member-operations__MemberTaskDrawer__tag","header":"member-operations__MemberTaskDrawer__header"};